<div class='container d-flex'>
  <div class='col w-60 justify-content-center'>
    Home-Seite
  </div>
</div>